import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import gameApp from './reducers'
import App from './components/App';

import './css/index.css';

import { challenges } from './data';

let store = createStore(gameApp, {
  slides: {
    activeSlide: challenges[0],
    allSlides: challenges
  }
});

function gerrymander(id){
  ReactDOM.render(
    <Provider store={store}>
    <App />
    </Provider>,
    document.getElementById(id)
  );
}

window.gerrymander = gerrymander;



// WEBPACK FOOTER //
// ./src/index.js